/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type BetweenDateValueConfigKind = (typeof BetweenDateValueConfigKind)[keyof typeof BetweenDateValueConfigKind];

export const BetweenDateValueConfigKind = {
  between: 'between',
} as const;
